export interface AnalyticsEvent {
  name: string;
  category?: string;
  payload?: string;
  value?: number;
  metadata?: Record<string, unknown>;
}

export type TrackEvent = (event: AnalyticsEvent) => void;

export const InteractiveSpotEvent = {
  MODAL_DISMISSED_WITHOUT_SPOT: 'WEB_INTERACTIVE_SPOT_MODAL_DISMISSED_WITHOUT_SPOT',
  MODAL_ACKNOWLEDGED_SUCCESS: 'WEB_INTERACTIVE_SPOT_MODAL_ACKNOWLEDGED_SUCCESS',
  SPOT_TAPPED: 'WEB_INTERACTIVE_SPOT_TAPPED',
  BOOKING_REQUEST_SENT: 'WEB_INTERACTIVE_SPOT_BOOKING_REQUEST_SENT',
  BOOKING_SPOT_RESERVED: 'WEB_INTERACTIVE_SPOT_BOOKING_SPOT_RESERVED',
  BOOKING_SPOT_SKIPPED: 'WEB_INTERACTIVE_SPOT_BOOKING_SPOT_SKIPPED',
  BOOKING_ERROR: 'WEB_INTERACTIVE_SPOT_BOOKING_ERROR',
  BOOKING_CTA_TAPPED: 'WEB_INTERACTIVE_SPOT_BOOKING_CTA_TAPPED',
  ROOM_LAYOUT_MAP_LOAD_ERROR: 'WEB_INTERACTIVE_SPOT_ROOM_LAYOUT_MAP_LOAD_ERROR',
} as const;

export type InteractiveSpotEvent =
  (typeof InteractiveSpotEvent)[keyof typeof InteractiveSpotEvent];
